var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivateMenuItemIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1C5.48421 1 1 5.48421 1 11C1 16.5158 5.48421 21 11 21C16.5158 21 21 16.5158 21 11C21 5.48421 16.5158 1 11 1ZM11 19.1684C6.49474 19.1684 2.83158 15.5052 2.83158 11C2.83158 6.49477 6.49477 2.83158 11 2.83158C15.5052 2.83158 19.1684 6.49477 19.1684 11C19.1684 15.5052 15.5052 19.1684 11 19.1684Z",
    fill: "white",
    stroke: "#343643",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3893 7.46326C14.3893 8.126 13.8519 8.66318 13.1892 8.66318C12.5264 8.66318 11.9893 8.126 11.9893 7.46326C11.9893 6.80051 12.5264 6.26318 13.1892 6.26318C13.8519 6.26318 14.3893 6.80051 14.3893 7.46326Z",
    fill: "white",
    stroke: "#343643",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2634 10.5369C13.9897 10.158 13.4214 10.158 13.1476 10.5369L12.6845 11.1685C12.6003 11.2948 12.3897 11.2948 12.3056 11.1685L10.3266 8.41062C10.0529 8.03175 9.48459 8.03175 9.21083 8.41062L5.84233 13.1685C5.5266 13.6107 5.84233 14.2422 6.38966 14.2422H15.5897C16.137 14.2422 16.4739 13.6105 16.137 13.1685L14.2634 10.5369Z",
    fill: "white",
    stroke: "#343643",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateMenuItemIcon);
export default __webpack_public_path__ + "static/media/PrivateMenuItemIcon.1df6c8ee1518db507b9525abc59ca433.svg";
export { ForwardRef as ReactComponent };